
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export const CategoryDistribution: React.FC = () => {
  // Mock data - would be replaced with actual API data
  const data = [
    { name: '5 Estrellas', value: 15, color: '#8884d8' },
    { name: '4 Estrellas', value: 25, color: '#83a6ed' },
    { name: '3 Estrellas', value: 45, color: '#8dd1e1' },
    { name: '2 Estrellas', value: 20, color: '#82ca9d' },
    { name: '1 Estrella', value: 10, color: '#a4de6c' },
  ];
  
  const COLORS = ['#8884d8', '#83a6ed', '#8dd1e1', '#82ca9d', '#a4de6c'];
  
  const config = {};
  data.forEach((entry, index) => {
    config[entry.name] = {
      label: entry.name,
      color: COLORS[index % COLORS.length],
    };
  });

  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Distribución por Categoría</CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <ChartContainer className="aspect-video h-64" config={config}>
          {/* Using a fragment to wrap multiple elements - fixes the children type issue */}
          <>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  nameKey="name"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <ChartTooltip
                  content={
                    <ChartTooltipContent nameKey="name" labelKey="value" />
                  }
                />
              </PieChart>
            </ResponsiveContainer>
            <ChartLegend
              payload={data.map((entry, index) => ({
                value: entry.name,
                color: COLORS[index % COLORS.length],
                dataKey: entry.name,
              }))}
            >
              <ChartLegendContent />
            </ChartLegend>
          </>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
